import { SaveFormat } from "expo-image-manipulator";
import { Alert, Image } from "react-native";
import * as ImageManipulator from "expo-image-manipulator";
import { captureException } from "../../common/sentry";

const IMG_MAX_SIZE = {
  width: 1570,
  height: 1570,
};

export async function processImage(
  imageURI: string,
  prefixActions: ImageManipulator.Action[] = []
) {
  try {
    const largestSide = new Promise<"height" | "width">((resolve) =>
      Image.getSize(
        imageURI,
        (width, height) => {
          if (width > height) {
            resolve("width");
          } else {
            resolve("height");
          }
        },
        () => {
          resolve("height");
        }
      )
    );

    const processedImage = await ImageManipulator.manipulateAsync(
      imageURI,
      [
        ...prefixActions,
        (await largestSide) === "width"
          ? {
              resize: { width: IMG_MAX_SIZE.width },
            }
          : {
              resize: { height: IMG_MAX_SIZE.height },
            },
      ],
      { format: SaveFormat.JPEG, compress: 0.7 }
    );

    return processedImage;
  } catch (e) {
    console.log("process image error");
    captureException(e);
    Alert.alert(
      "Failed to process image",
      "Please try again later or report the issue to Storesprint"
    );
    throw e;
  }
}
